import React from 'react';
import { addLocale } from 'primereact/api';
import { locales } from '@ancert/aui-utils';

import { BrowserRouter } from 'react-router-dom';
import { AUINotificationContext } from '@ancert/aui-notification-context';

import Routes from './routes';
import Layout from './containers/Layout';

import { ArchivosAdjuntosProvider } from './context/archivosAdjuntos.context';
import { PersonasImplicadasProvider } from './context/personasImplicadas.context';
import { SessionProvider } from './context/session.context';
import { ThemeProvider } from './context/theme.context';
import { BackOfficeProvider } from './context/backOffice.context';
import KlaroCookies from './components/KlaroCookies';

import { HOMEPAGE } from './constants/routes.constants';

import '@ancert/aui-styles/prime.scss';
import '@ancert/aui-styles/styles.scss';
// import './assets/themes/portales.css'; // Este fichero no se debe modificar

import './styles/styles.scss';

/**
 * @component
 * @returns {React.ReactElement} - Devuelve un componente Layout
 */
function App() {
  addLocale('es', locales.spanish);
  return (
    <BrowserRouter basename={HOMEPAGE}>
      <KlaroCookies>
        <AUINotificationContext>
          <BackOfficeProvider>
            <ThemeProvider>
              <SessionProvider>
                <Layout>
                  <ArchivosAdjuntosProvider>
                    <PersonasImplicadasProvider>
                      <Routes />
                    </PersonasImplicadasProvider>
                  </ArchivosAdjuntosProvider>
                </Layout>
              </SessionProvider>
            </ThemeProvider>
          </BackOfficeProvider>
        </AUINotificationContext>
      </KlaroCookies>
    </BrowserRouter>
  );
}

export default App;
